import { render, staticRenderFns } from "./addARecord.vue?vue&type=template&id=8fecaacc&scoped=true&"
import script from "./addARecord.vue?vue&type=script&lang=js&"
export * from "./addARecord.vue?vue&type=script&lang=js&"
import style0 from "./addARecord.vue?vue&type=style&index=0&id=8fecaacc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fecaacc",
  null
  
)

export default component.exports